import type { DestinationMapData } from '@/scopes/products/domain/types'
import type { NearbyAccosAPIResponse } from './types'

export interface DestinationMapResponseMapper {
  map: (data: NearbyAccosAPIResponse) => DestinationMapData
}

export function createDestinationMapResponseMapper(): DestinationMapResponseMapper {
  function map(data: NearbyAccosAPIResponse): DestinationMapData {
    return {
      accommodations: data.accommodations
        // TODO make sure that removing the accos without coordinates is the right thing to do
        .filter(acco => acco.latitude !== 0 && acco.longitude !== 0)
        .map(acco => ({
          id: acco.accommodationId,
          lat: acco.latitude,
          lng: acco.longitude,
        })),
    }
  }

  return { map }
}
